import commonMapping from "@/mapping/common";

const default_policy_list = [
  { value: "allow", config: "allow", label: "allow_mark" },
  { value: "block",  config: "block", label: "deny_mark" },
];


export const macAcl = {
  default_policy: default_policy_list,
};

export default macAcl;
